import React from 'react'
import GoodsContent from './router'
import { getBEMCls } from '@/utils/classname'
import { Column, Expaned } from '@/components/layout/layout'

import './goods-storage.scss'
import { RouteComponentProps, useHistory } from 'react-router'
import Tianxing from '@/assets/images/tianxing.svg'
import { MALL_GOODS_SHELF } from '../../mall-manage/mall-shelf/router'

const Goods = (props: RouteComponentProps) => {
    const getCls = (el?: string, m?: string) => getBEMCls('sg-goods', el, m)

    const histroy = useHistory()

    return (
        <Column className={getCls()}>
            <div className={getCls('header')}>
                <div data-font-size-24 data-color-000>
                    商品库
                </div>
                <div
                    className={getCls('tag')}
                    onClick={() => {
                        histroy.replace(MALL_GOODS_SHELF)
                    }}
                >
                    <img src={Tianxing} alt="" className={getCls('img')} />
                    商城货架
                </div>
            </div>
            <Expaned className={getCls('content')}>
                <GoodsContent {...props} />
            </Expaned>
        </Column>
    )
}

export default Goods
